import PropTypes from 'prop-types';
import { STATUS } from '~/common/status';
import { USER_ORGANIZATION_TYPE } from '~/common/constants';

export const reactRouterProps = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.object
  }),
  intl: PropTypes.any
};

export const FormAnt = PropTypes.shape({
  getFieldDecorator: PropTypes.func.isRequired,
  validateFieldsAndScroll: PropTypes.func.isRequired,
  isFieldsTouched: PropTypes.func.isRequired
});

export const userType = PropTypes.oneOf([
  USER_ORGANIZATION_TYPE.INTERNAL,
  USER_ORGANIZATION_TYPE.EXTERNAL
]).isRequired;

export const roleStatusEnum = PropTypes.oneOf([
  STATUS.ACTIVE,
  STATUS.INACTIVE,
  STATUS.DELETED
]);

export const userStatusEnum = PropTypes.oneOf([
  STATUS.ACTIVE,
  STATUS.INACTIVE,
  STATUS.NEW,
  STATUS.INVITED,
  STATUS.DELETED,
  STATUS.LOCKED
]);

export const userStatusSearchEnum = PropTypes.oneOf([
  STATUS.ALL,
  STATUS.ACTIVE,
  STATUS.INACTIVE,
  STATUS.NEW,
  STATUS.INVITED,
  STATUS.DELETED,
  STATUS.LOCKED
]);

export const userFromList = PropTypes.shape({
  id: PropTypes.string.isRequired,
  email: PropTypes.string,
  login: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  invitedDate: PropTypes.string,
  status: userStatusEnum.isRequired,
  employeeNumber: PropTypes.string
});

export const profileUserObject = PropTypes.shape({
  address: PropTypes.string.isRequired,
  birthDate: PropTypes.string.isRequired,
  email: PropTypes.string,
  login: PropTypes.string.isRequired,
  employeeNumber: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  joinedDate: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  primaryMobile: PropTypes.string.isRequired,
  secondaryMobile: PropTypes.string.isRequired,
  workPhone: PropTypes.string.isRequired,
  languageCode: PropTypes.string
});

export const profileData = PropTypes.shape({
  user: profileUserObject,
  isLoaded: PropTypes.bool.isRequired,
  defaultAvatar: PropTypes.string.isRequired
});

export const roleShape = PropTypes.shape({
  airlineIds: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  privilegeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  status: roleStatusEnum.isRequired
});

export const paginationObject = PropTypes.shape({
  pageSize: PropTypes.number.isRequired,
  showQuickJumper: PropTypes.bool.isRequired,
  showSizeChanger: PropTypes.bool.isRequired,
  total: PropTypes.number.isRequired
});

export const reactChildren = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node
]).isRequired;

export const privilegeShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  dependsOnPrivilegesIds: PropTypes.arrayOf(PropTypes.string).isRequired
});

export const moduleShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  privileges: PropTypes.arrayOf(privilegeShape).isRequired
});

export const microproductShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  modules: PropTypes.arrayOf(moduleShape).isRequired
});

export const roleFilterOptionShape = PropTypes.shape({
  filterBy: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired
});

export const roleFilterOptions = PropTypes.arrayOf(roleFilterOptionShape);

export const microproductsShape = PropTypes.arrayOf(microproductShape);

export const airlineShape = PropTypes.exact({
  id: PropTypes.string.isRequired,
  iataCode: PropTypes.string.isRequired
});

export const airlinesShape = PropTypes.arrayOf(airlineShape);
